"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("../../models");
/**
 * Mixin class for Location Services.
 */
var LocationServicesMixin = /** @class */ (function () {
    function LocationServicesMixin() {
    }
    /**
     * Gets agency region.
     * @param agencyId
     * @param callback
     */
    LocationServicesMixin.prototype.getAgencyRegion = function (agencyId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.AgencyRegion.parse));
        };
        this.http.get("/agencies/" + agencyId + "/region", null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Geocodes location.
     * @param agencyId
     * @param location
     * @param city
     * @param state
     * @param callback
     */
    LocationServicesMixin.prototype.geocode = function (agencyId, location, city, state, callback) {
        var _this = this;
        var geocodeBody = {
            locationDesc: location,
            city: city,
            state: state,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.Geocode.parse));
        };
        this.http.get("/agencies/" + agencyId + "/geocode", geocodeBody, this.unauthenticatedCallback(wrappedCallback));
    };
    return LocationServicesMixin;
}());
exports.default = LocationServicesMixin;
//# sourceMappingURL=LocationServicesMixin.js.map